import React from 'react'
import { withRouter } from 'react-router-dom'
import { Result, Button } from 'antd'

class NotFound extends React.Component {
    onClick = (e) => {
        this.props.history.push('/')
    }
    
    render() {
        return (
            <Result
                status="404"
                title="404"
                subTitle="Sorry, the page you visited does not exist."
                extra={<Button type="primary" onClick={this.onClick}>Back Home</Button>}
            />
        )
    }
}

export default withRouter(NotFound)